import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Onboarding from '@/pages/Onboarding';
import Dashboard from '@/pages/Dashboard';
import Conversations from '@/pages/Conversations';
import Automation from '@/pages/Automation';
import Products from '@/pages/Products';
import FAQs from '@/pages/FAQs';
import Leads from '@/pages/Leads';
import Analytics from '@/pages/Analytics';
import Settings from '@/pages/Settings';
import Catalog from '@/pages/Catalog';
import LandingPage from '@/pages/LandingPage';   // ← NEW
import AuthCallback from '@/pages/auth/Callback';
import SubscriptionPage from '@/pages/SubscriptionPage';
import useThemeStore from '@/store/useThemeStore';
import '@/index.css';

function App() {
  const initTheme = useThemeStore((state) => state.initTheme);

  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return (
    <>
      <BrowserRouter>
        <Routes>

          {/* ── Landing Page (public, default "/" route) ── */}
          <Route path="/" element={<LandingPage />} />

          {/* ── Auth Routes (public) ── */}
          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />  {/* ← YAHAN */}

          {/* ── Onboarding (protected) ── */}
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <Onboarding />
              </ProtectedRoute>
            }
          />

          {/* ── App Routes (protected, nested under Layout) ── */}
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index                   element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard"        element={<Dashboard />} />
            <Route path="conversations"    element={<Conversations />} />
            <Route path="automation"       element={<Automation />} />
            <Route path="products"         element={<Products />} />
            <Route path="catalog"          element={<Catalog />} />   {/* ← YEH ADD KARO */}
            <Route path="faqs"             element={<FAQs />} />
            <Route path="leads"            element={<Leads />} />
            <Route path="analytics"        element={<Analytics />} />
            <Route path="settings"         element={<Settings />} />
            // Route mein:
            <Route path="subscription" element={<SubscriptionPage />} />
          </Route>

          {/* ── Catch-all → Landing ── */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;